import { render, staticRenderFns } from "./HelpSupport.vue?vue&type=template&id=2748b64e&"
import script from "./HelpSupport.vue?vue&type=script&lang=js&"
export * from "./HelpSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports